import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { usePortalAiClient } from '#src/api/ai.ts'
import { completeMcpAuthorization } from '#src/mcp/mintMcp.ts'

/*
 * Lands the OAuth redirect from the remote MCP server: exchanges the code for
 * tokens (via the server proxy) and returns the user to where they started.
 */
export function McpCallbackPage() {
  const client = usePortalAiClient()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const [error, setError] = useState<string>()
  const handled = useRef(false)

  useEffect(() => {
    if (handled.current) {
      return
    }
    handled.current = true
    completeMcpAuthorization(client, params)
      .then((returnTo) => navigate(returnTo, { replace: true }))
      .catch((cause: unknown) => {
        setError(
          cause instanceof Error ? cause.message : 'Authorization failed'
        )
      })
  }, [client, navigate, params])

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-2 text-center">
      {error ? (
        <>
          <p className="text-sm font-medium text-destructive">
            Could not connect to the MCP server
          </p>
          <p className="text-sm text-muted-foreground">{error}</p>
          <button
            type="button"
            className="mt-2 text-sm underline"
            onClick={() => navigate('/', { replace: true })}
          >
            Back to Orbit
          </button>
        </>
      ) : (
        <p className="text-sm text-muted-foreground">
          Connecting to MCP server…
        </p>
      )}
    </div>
  )
}
